import {allActionURL, okrActionURL, oneActionURL, oneOkrActionURL, oneOkrURL} from "../../services/api";
import {
    GET_ACTION,
    SET_FAIL_MESSAGE,
    FETCH_ACTION_FAIL,
    POST_ACTION,
    POST_ACTION_FAIL,
    DELETE_ACTION,
    DELETE_ACTION_FAIL,
    PATCH_ACTION,
    PATCH_ACTION_FAIL,
    GET_ALL_ACTIONS,
    GET_ALL_ACTIONS_FAIL,
    GET_OKR_ACTION,
    FETCH_OKR_ACTION_FAIL,
    SET_OKR_FAIL_MESSAGE,
    POST_OKR_ACTION,
    POST_OKR_ACTION_FAIL,
    DELETE_OKR_ACTION,
    DELETE_OKR_ACTION_FAIL,
    PATCH_OKR_ACTION, PATCH_OKR_ACTION_FAIL, GET_ALL_OKR_ACTIONS, GET_ALL_OKR_ACTIONS_FAIL
} from "./actionTypes";
import {checkErrorMessage} from "../../utils/utils";
import api from "../../services/instanceapi"

export const getOneAction = (id) => async (dispatch) => {
    try {
        const action = await api.get(oneActionURL(id))
        dispatch({
            type: GET_ACTION,
            payload: {
                name: action.data.name,
                pilot: action.data.pilot,
                startDate: action.data.startDate,
                deadline: action.data.deadline,
                criticality: action.data.criticality,
                keyResultId: action.data.keyResultId,
                projectId: action.data.projectId,
                advancement: action.data.advancement,
                comment:action.data.comment,
                tags:action.data.tags,
                availableTags:action.data.availableTags,
                status: 200,
                message: "OK"
            }
        });
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: FETCH_ACTION_FAIL,
            });
            dispatch({
                type: SET_FAIL_MESSAGE,
                payload: {
                    message: message,
                    status: status,
                },
            });
        }
    }
}

export const getOneOkrAction = (id) => async (dispatch) => {
    try {
        const action = await api.get(oneOkrActionURL(id))
        dispatch({
            type: GET_OKR_ACTION,
            payload: {
                name: action.data.name,
                pilot: action.data.pilot,
                startDate: action.data.startDate,
                deadline: action.data.deadline,
                criticality: action.data.criticality,
                keyResultsId: action.data.keyResultsId,
                advancement: action.data.advancement,
                comment:action.data.comment,
                tags:action.data.tags,
                availableTags:action.data.availableTags,
                status: 200,
                message: "OK"
            }
        });
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: FETCH_OKR_ACTION_FAIL,
            });
            dispatch({
                type: SET_OKR_FAIL_MESSAGE,
                payload: {
                    message: message,
                    status: status,
                },
            });
        }
    }
}

export const postOneAction = (actionData) => async (dispatch) => {
    try {
        const action = await api.post(allActionURL(), actionData);
        const data = action.data;
        dispatch({
            type: POST_ACTION,
            payload: {
                name: data.name,
                pilotId: data.pilotId,
                criticality: data.criticality,
                projectId: data.projectId,
                advancement: data.advancement,
                comment:data.comment,
                status: 201,
                message: "Created"
            }
        });
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: POST_ACTION_FAIL,
            });
            dispatch({
                type: SET_FAIL_MESSAGE,
                payload: {
                    message: message,
                    status: status,
                },
            });
        }
        return Promise.reject(status)
    }
}

export const postOneOkrAction = (id,actionData) => async (dispatch) => {
    try {
        const action = await api.post(okrActionURL(id), actionData);
        const data = action.data;
        dispatch({
            type: POST_OKR_ACTION,
            payload: {
                name: data.name,
                pilotId: data.pilotId,
                criticality: data.criticality,
                advancement: data.advancement,
                comment:data.comment,
                status: 201,
                message: "Created"
            }
        });
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: POST_OKR_ACTION_FAIL,
            });
            dispatch({
                type: SET_OKR_FAIL_MESSAGE,
                payload: {
                    message: message,
                    status: status,
                },
            });
        }
        return Promise.reject(status)
    }
}

export const deleteOneAction = (id) => async (dispatch) => {
    try {
        const actionDeleted = await api.delete(oneActionURL(id))
        dispatch({
            type: DELETE_ACTION,
            payload: {
                deleted: actionDeleted.status,
                status: 204,
                message: "Deleted",
            }
        });
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: DELETE_ACTION_FAIL,
            });
            dispatch({
                type: SET_FAIL_MESSAGE,
                payload: {
                    message: message,
                    status:status
                },
            });
        }
        return Promise.reject(e)
    }
}

export const deleteOneOkrAction = (id) => async (dispatch) => {
    try {
        const actionDeleted = await api.delete(oneOkrURL(id))
        dispatch({
            type: DELETE_OKR_ACTION,
            payload: {
                deleted: actionDeleted.status,
                status: 204,
                message: "Deleted",
            }
        });
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: DELETE_OKR_ACTION_FAIL,
            });
            dispatch({
                type: SET_OKR_FAIL_MESSAGE,
                payload: {
                    message: message,
                    status:status
                },
            });
        }
        return Promise.reject(e)
    }
}

export const patchOneAction = (id, action, headers) => async (dispatch) => {
    try {
        const actionUpdated = await api.patch(oneActionURL(id), action, headers)
        dispatch({
            type: PATCH_ACTION,
            payload: {
                updated: actionUpdated.status,
                status: 200,
                message: "Updated",
            }
        });
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: PATCH_ACTION_FAIL,
            });
            dispatch({
                type: SET_FAIL_MESSAGE,
                payload: {
                    message: message,
                    status:status,
                },
            });
        }
    }
}
export const patchOneOkrAction = (id, action, headers) => async (dispatch) => {
    try {
        const actionUpdated = await api.patch(oneOkrActionURL(id), action, headers)
        dispatch({
            type: PATCH_OKR_ACTION,
            payload: {
                updated: actionUpdated.status,
                status: 200,
                message: "Updated",
            }
        });
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: PATCH_OKR_ACTION_FAIL,
            });
            dispatch({
                type: SET_OKR_FAIL_MESSAGE,
                payload: {
                    message: message,
                    status:status,
                },
            });
        }
    }
}


export const loadActions = (currentUserId) => async (dispatch) => {
    try {
        const {data} = await api.get(allActionURL(currentUserId))
        dispatch({
            type: GET_ALL_ACTIONS,
            payload: {
                actions: data
            }
        });
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status

        if (status !== 200) {
            dispatch({
                type: GET_ALL_ACTIONS_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            });
        }
        return Promise.reject(e);
    }
}

export const loadOkrActions = (id) => async (dispatch) => {
    try {
        const {data} = await api.get(okrActionURL(id))
        dispatch({
            type: GET_ALL_OKR_ACTIONS,
            payload: {
                actions: data
            }
        });
        return Promise.resolve()
    } catch (e) {
        const message = checkErrorMessage(e)
        const status = e.response.status

        if (status !== 200) {
            dispatch({
                type: GET_ALL_OKR_ACTIONS_FAIL,
                payload: {
                    status: status,
                    message: message
                }
            });
        }
        return Promise.reject(e);
    }
}